import { FC, ReactNode } from "react";

interface MiniTableProps {
    children: ReactNode;
    title?: string;
    link?: {
        title: string;
        url: string;
    }
}
export const MiniTable: FC<MiniTableProps> = ({
    children,
    title,
    link,
}) => {
    return (
        <div className="p-2 sm:px-6 sm:py-4 bg-slate-100/95 rounded-xl w-full sm:max-w-[440px]">
            <div className="flex flex-row justify-between items-center pb-4">
                {title && <div className="text-xl w-full text-left text-slate-950 font-medium">{title}</div>}
                {link && <a href={link.url} className="transition-all bg-slate-200 px-4 py-2 rounded-full cursor-pointer active:scale-95 hover:bg-sky-600 hover:text-white text-sky-900 hover:no-underline hover:shadow-sm">{link.title}</a>}
            </div>
            {children}
        </div>
    );
}